import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import React, { lazy } from "react";
import styled from "styled-components";

import { IReviewSummary } from "@faire/retailer/lib/buildReviewSummary";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IBrandReviewsListProps {
  title: string | undefined;
  brandReviewSummary: IReviewSummary;
  productReviewSummary?: IReviewSummary;
  brandAvatar?: IImage;
  brandToken: string;
  brandName: string;
  productToken?: string;
  brand: Pick<IBrand, "is_top_shop" | "is_apparel">;
  product?: IProductPageResponse.IPdpProduct;
  useLastDeliveredOrder?: boolean;
  containerName?: string;
}

export const LazyBrandReviewsList = lazy(() =>
  import(
    /* webpackChunkName: "retailer-brand-reviews-list" */ "./BrandReviewsList"
  )
    .then((m) => ({ default: m.BrandReviewsList }))
    .catch(handleComponentLoadError)
);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyBrandReviewsList.displayName = "LazyBrandReviewsList";

export const BrandReviewsFallback: React.FC = () => (
  <Wrapper>
    <LoadingSpinner />
  </Wrapper>
);

const Wrapper = styled(Row).attrs({
  align: "center",
  justify: "center",
})`
  height: 1000px;
`;
